import stringDelimiter from 'CampaignSystem/utils/stringDelimiter'

const currentLang = () => localStorage.getItem('i18nextLng')
const RTL = () =>
  currentLang() === 'ar' || currentLang() === stringDelimiter('ar')
const LTR = () =>
  currentLang() === 'en' || currentLang() === stringDelimiter('en')

export { RTL, LTR }
